import { Else, If, Then } from 'react-if';
import cns from 'classnames';
import { useTranslation } from 'next-i18next';
import { BoltFillIcon } from '@zep/icons';
import { PlanType } from '@zep/types';
import { White } from '@zep/ui-tokens/color';
import S from './PlanTypeLabel.module.scss';
export const PlanTypeLabel = ({
  planType,
  maxCcu
}: {
  planType?: PlanType;
  maxCcu?: number;
}) => {
  const {
    t
  } = useTranslation(['subscription']);
  const gradientColor = planType === 'BASIC' ? 'linear-gradient(132deg, #24B6EC 1.68%, #1DCFAF 96.63%)' : planType === 'PRO' ? 'linear-gradient(132deg, #588AFF 1.68%, #A572FF 96.63%)' : 'linear-gradient(132deg, #27262E 1.68%, #949CBD 96.63%)';
  return <div className={cns(S.plan_type_label, S[`${planType?.toLowerCase()}`])} data-sentry-component="PlanTypeLabel" data-sentry-source-file="PlanTypeLabel.tsx">
      {planType !== 'FREE' && <div className={'flex size-[17px] items-center justify-center rounded-[5px]'} style={{
      background: gradientColor
    }}>
          <BoltFillIcon width={12} height={12} fill={White} />
        </div>}
      {maxCcu ? <>
          <span className="font-bold">
            {planType?.toString().toUpperCase()}
          </span>
          <span className={S.line} />
          <If condition={maxCcu < 0}>
            <Then>
              <span>{t('subscription:pricing.calculation.barUnlimited')}</span>
            </Then>
            <Else>
              <span>
                {t('subscription:pricing.plansCommon.maxPeopleNumber', {
              ccu: maxCcu
            })}
              </span>
            </Else>
          </If>
        </> : <span>{`${planType?.toString().toUpperCase()} PLAN`}</span>}
    </div>;
};